module.exports = ".demo {\n  background-color: #3A3A3C; }\n"